import React, { useState, useEffect } from "react";
import { useUserContext } from "../contexts/UserContext";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer";
import toast, { Toaster } from "react-hot-toast";

export default function Profil() {
 const { user, token, login, getAuthHeaders } = useUserContext();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    fullname: "",
    email: "",
    number: "",
    address: "",
    password: "",
    logo: null,
  });
  const [photoPreview, setPhotoPreview] = useState(null);

  // ⚡ Récupération du profil admin
useEffect(() => {
  if (!user || !token) return;

  const fetchAdminProfile = async () => {
    try {
      const res = await fetch(
        `http://localhost:8080/admin/profile/${user._id}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setFormData({
          username: data.username || "",
          fullname: data.fullname || "",
          email: data.email || "",
          number: data.telephone || "",
          address: data.adresse || "",
          password: "",
          logo: data.companyInfo?.logo || null,
        });

        setPhotoPreview(data.companyInfo?.logo || null);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error("Erreur serveur : " + err.message);
    }
  };

  fetchAdminProfile();
}, [user, token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFormData({ ...formData, logo: file });
    setPhotoPreview(URL.createObjectURL(file));
  };

// Utilise getAuthHeaders() pour inclure le token correctement
const handleUpdate = async (e) => {
  e.preventDefault();

  const data = new FormData();

  Object.keys(formData).forEach((key) => {
    if (formData[key] !== "" && formData[key] !== null) {
      data.append(key, formData[key]);
    }
  });

  try {
    const res = await fetch(`http://localhost:8080/admin/update/${user._id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    const result = await res.json();

    if (res.ok) {
      login(result.admin, token);
      toast.success("Profil mis à jour !");
      setShowModal(false);
    } else {
      toast.error(result.message || "Erreur lors de la mise à jour");
    }
  } catch (err) {
    toast.error("Erreur serveur : " + err.message);
  }
};
  
console.log("Session actuelle :", JSON.parse(localStorage.getItem("prestationSession")));

  if (!user) return <p>Chargement...</p>;

  return (
    <>
      <Toaster position="top-right" />
      <Navbar />

      <div className="profil-page">
        <h2>Mon Profil</h2>
        <div className="profil-details">
          <div className="profil-logo-section">
            {photoPreview ? (
              <img
                src={
                  photoPreview.startsWith("http")
                    ? photoPreview
                    : `http://localhost:8080/uploads/${photoPreview}`
                }
                alt="Logo"
                className="profil-logo"
              />
            ) : (
              <div className="profil-logo-placeholder">
                {formData.fullname?.charAt(0)?.toUpperCase() || ""}
              </div>
            )}
          </div>

          <p><strong>Nom :</strong> {formData.fullname || "—"}</p>
          <p><strong>Email :</strong> {formData.email || "—"}</p>
          <p><strong>Téléphone :</strong> {formData.number || "—"}</p>
          <p><strong>Adresse :</strong> {formData.address || "—"}</p>
          <p><strong>Username :</strong> {formData.username || "—"}</p>

          <button className="btn-save" onClick={() => setShowModal(true)}>
            Modifier mon profil
          </button>
        </div>
      </div>

      {/* ================= MODAL ================= */}
    {showModal && (
  <div className="modal-overlay">
    <div className="modal-container">
      <h3>Modifier le profil</h3>

      <form onSubmit={handleUpdate} encType="multipart/form-data">
        <div className="photo-section">
          {photoPreview ? (
            <img src={photoPreview} alt="Preview" className="preview-img" />
          ) : (
            <div className="profil-logo-placeholder small">
              {formData.fullname?.charAt(0)?.toUpperCase()}
            </div>
          )}
          <input type="file" accept="image/*" onChange={handlePhotoChange} />
        </div>

        <input
          type="text"
          name="username"
          value={formData.username || ""}
          onChange={handleChange}
          placeholder="Nom d'utilisateur"
        />
        <input
          type="text"
          name="fullname"
          value={formData.fullname || ""}
          onChange={handleChange}
          placeholder="Nom complet"
        />
        <input
          type="email"
          name="email"
          value={formData.email || ""}
          onChange={handleChange}
          placeholder="Email"
        />
        <input
          type="password"
          name="password"
          value={formData.password || ""}
          onChange={handleChange}
          placeholder="Mot de passe (laisser vide si inchangé)"
        />
        <input
          type="text"
          name="number"
          value={formData.number || ""}
          onChange={handleChange}
          placeholder="Téléphone"
        />
        <input
          type="text"
          name="address"
          value={formData.address || ""}
          onChange={handleChange}
          placeholder="Adresse"
        />

        <div className="modal-buttons">
          <button type="submit" className="btn-save">Enregistrer</button>
          <button
            type="button"
            className="btn-cancel"
            onClick={() => setShowModal(false)}
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  </div>
)}
      <Footer />

      <style>
        {`
          /* =========================
             PAGE PROFIL
          ========================= */

.profil-page {
  min-height: 80vh;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f4f6f9, #e9eef5);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profil-page h2 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #2c3e50;
}

/* =========================
   CARD PROFIL
========================= */

.profil-details {
  width: 100%;
  max-width: 500px;
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: 0.3s ease;
}

.profil-details:hover {
  transform: translateY(-4px);
}

.profil-details p {
  font-size: 15px;
  margin: 10px 0;
  color: #555;
}

.profil-details strong {
  color: #2c3e50;
}

/* =========================
   BOUTONS
========================= */

.btn-save {
  margin-top: 20px;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: #3498db;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: 0.3s ease;
}

.btn-save:hover {
  background: #2980b9;
}

.btn-cancel {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: #e74c3c;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: 0.3s ease;
}

.btn-cancel:hover {
  background: #c0392b;
}

/* =========================
   MODAL
========================= */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  width: 95%;
  max-width: 500px;
  background: white;
  padding: 30px;
  border-radius: 16px;
  animation: fadeIn 0.3s ease-in-out;
}

.modal-container h3 {
  margin-bottom: 20px;
  font-weight: 600;
  color: #2c3e50;
}

/* =========================
   FORMULAIRE
========================= */

.modal-container form input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid #ddd;
  outline: none;
  transition: 0.2s;
}

.modal-container form input:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

/* =========================
   PHOTO SECTION
========================= */

.photo-section {
  text-align: center;
  margin-bottom: 15px;
}

.preview-img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
  border: 3px solid #3498db;
}

/* =========================
   MODAL BUTTONS
========================= */

.modal-buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}

/* =========================
   ANIMATION
========================= */

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =========================
   RESPONSIVE
========================= */

@media (max-width: 480px) {
  .profil-details {
    padding: 20px;
  }

  .modal-container {
    padding: 20px;
  }

  .modal-buttons {
    flex-direction: column;
  }
}

/* =========================
   LOGO SECTION
========================= */

.profil-logo-section {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.profil-logo {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid #3498db;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transition: 0.3s ease;
}

.profil-logo:hover {
  transform: scale(1.05);
}

/* Si pas de photo */
.profil-logo-placeholder {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
  font-size: 48px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profil-logo-placeholder.small {
  width: 100px;
  height: 100px;
  font-size: 32px;
}
  /* =====================================
   RESPONSIVE GLOBAL
===================================== */

/* 📱 Mobile petit (320px - 480px) */
@media (max-width: 480px) {

  .profil-page {
    padding: 20px 15px;
  }

  .profil-page h2 {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .profil-details {
    padding: 20px;
    border-radius: 12px;
  }

  .profil-details p {
    font-size: 14px;
  }

  .profil-logo {
    width: 100px;
    height: 100px;
  }

  .profil-logo-placeholder {
    width: 100px;
    height: 100px;
    font-size: 36px;
  }

  .btn-save {
    width: 100%;
    padding: 12px;
    font-size: 14px;
  }

  .modal-container {
    width: 95%;
    padding: 20px;
  }

  .modal-buttons {
    flex-direction: column;
  }

  .modal-buttons button {
    width: 100%;
  }

  .preview-img {
    width: 80px;
    height: 80px;
  }

}

/* 📱 Grand mobile / petit tablet */
@media (min-width: 481px) and (max-width: 768px) {

  .profil-page {
    padding: 30px 20px;
  }

  .profil-details {
    max-width: 90%;
    padding: 25px;
  }

  .profil-logo {
    width: 120px;
    height: 120px;
  }

  .profil-logo-placeholder {
    width: 120px;
    height: 120px;
    font-size: 40px;
  }

  .modal-container {
    max-width: 450px;
  }

}

/* 💻 Tablet */
@media (min-width: 769px) and (max-width: 1024px) {

  .profil-details {
    max-width: 600px;
  }

  .modal-container {
    max-width: 520px;
  }

}

/* 🖥 Desktop large */
@media (min-width: 1025px) and (max-width: 1440px) {

  .profil-details {
    max-width: 550px;
  }

}

/* 🖥 Très grands écrans */
@media (min-width: 1441px) {

  .profil-page {
    padding: 60px 20px;
  }

  .profil-details {
    max-width: 650px;
    padding: 40px;
  }

  .profil-page h2 {
    font-size: 32px;
  }

}
          `}
      </style>
    </>
  );
}